import React from 'react';
import { TextField, Grid, Typography, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import { useOutletContext } from 'react-router-dom';

const GuardianDetailsStep = () => {
    // Receive the errors object from the parent ApplicationFormPage
    const { formData, handleInputChange, errors } = useOutletContext();
    const data = formData.guardian || {};

    return (
        <>
            <Typography variant="h6" gutterBottom>2. Parent / Guardian / Member Details</Typography>
            <Grid container spacing={3}>
                 <Grid item xs={12}>
                    <TextField
                        required
                        name="relationToApplicant"
                        label="Relation to Applicant"
                        fullWidth
                        value={data.relationToApplicant || ''}
                        onChange={(e) => handleInputChange('guardian', e)}
                        // Display validation error if it exists
                        error={!!errors.relationToApplicant}
                        helperText={errors.relationToApplicant || "e.g. Father, Mother, Self"}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        name="surname"
                        label="Surname"
                        fullWidth
                        value={data.surname || ''}
                        onChange={(e) => handleInputChange('guardian', e)}
                        error={!!errors.surname}
                        helperText={errors.surname}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        name="firstNames"
                        label="First Names in Full"
                        fullWidth
                        value={data.firstNames || ''}
                        onChange={(e) => handleInputChange('guardian', e)}
                        error={!!errors.firstNames}
                        helperText={errors.firstNames}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        name="idNumber"
                        label="Identity or Passport Number"
                        fullWidth
                        value={data.idNumber || ''}
                        onChange={(e) => handleInputChange('guardian', e)}
                        error={!!errors.idNumber}
                        helperText={errors.idNumber}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField 
                        name="cellNo" 
                        label="Cellphone Number" 
                        fullWidth 
                        value={data.cellNo || ''} 
                        onChange={(e) => handleInputChange('guardian', e)} 
                    />
                </Grid>
                <Grid item xs={12}>
                    <TextField 
                        name="email" 
                        label="Email Address" 
                        type="email" 
                        fullWidth 
                        value={data.email || ''} 
                        onChange={(e) => handleInputChange('guardian', e)} 
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <TextField
                        required
                        name="company"
                        label="Name of Company"
                        fullWidth
                        value={data.company || ''}
                        onChange={(e) => handleInputChange('guardian', e)}
                        error={!!errors.company}
                        helperText={errors.company}
                    />
                </Grid>
                <Grid item xs={12} sm={6}>
                    <FormControl fullWidth required error={!!errors.industry}>
                        <InputLabel>Industry</InputLabel>
                        <Select 
                            name="industry" 
                            value={data.industry || ''} 
                            label="Industry" 
                            onChange={(e) => handleInputChange('guardian', e)}
                        >
                            <MenuItem value="Mining">Mining</MenuItem>
                            <MenuItem value="Energy">Energy</MenuItem>
                            <MenuItem value="Construction">Construction</MenuItem>
                        </Select>
                        {errors.industry && <FormHelperText>{errors.industry}</FormHelperText>}
                    </FormControl>
                </Grid>
            </Grid>
        </>
    );
};

export default GuardianDetailsStep;